module.exports = __webpack_public_path__ + "static/img/reference_page top img_mobile.66f84f42.jpg";